// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : REMOVE UNWANTED VARIABLE
// MODFIED DATA : 10-09-2025
import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/********************* FETCH REQUEST REPORT DETAILS START *********************** */
export const requestReportDetailsFetch = (fetchData: any) => {
	const data = {
		FetchRequestedReportToken: fetchData,
	};
	const url = `${API_URL}fetchRequestedReport`;
	return makeApiCall(url, data);
};
/********************* FETCH REQUEST REPORT DETAILS END *********************** */

/********************* ADD REQUEST REPORT DETAILS START *********************** */
export const requestReportDetailsAdd = (fetchData: any) => {
	const data = {
		AddRequestedReportToken: fetchData,
	};
	const url = `${API_URL}addRequestedReport`;
	return makeApiCall(url, data);
};

/********************* DELETE REQUEST REPORT DETAILS START *********************** */
export const requestReportDetailsDelete = (fetchData: any) => {
	const data = {
		DeleteRequestedReportToken: fetchData,
	};
	const url = `${API_URL}deleteRequestedReportExcel`;
	return makeApiCall(url, data);
};
/********************* DELETE REQUEST REPORT DETAILS END *********************** */
